import { render, staticRenderFns } from "./teacherAttestationAnalysis.vue?vue&type=template&id=7e211e9b&scoped=true&"
import script from "./teacherAttestationAnalysis.vue?vue&type=script&lang=js&"
export * from "./teacherAttestationAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./teacherAttestationAnalysis.vue?vue&type=style&index=0&id=7e211e9b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e211e9b",
  null
  
)

export default component.exports